import { createSlice } from "@reduxjs/toolkit";

export const vineyardsSlice = createSlice({
    name: 'vineyards',
    initialState: [],
    reducers: {
        empty: state => {
            return []
        },
        setVineyards: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
        },
        add: (state, action) => {
            state.push(action.payload);
            return state;
        },
        update: (state, action) => {
            const foundedIndex = state.findIndex((vineyard) => vineyard.id === action.payload?.id);
            if (foundedIndex !== -1) {
                state[foundedIndex] = action.payload
            }
            return state
        },
        remove: (state, action) => {
            const foundedIndex = state.findIndex((vineyard) => vineyard.id === action.payload?.id);
            if (foundedIndex !== -1) {
                state.splice(foundedIndex, 1)
            }
            return state
        }
    }
});

export const {
    setVineyards,
    empty,
    add,
    update,
    remove
} = vineyardsSlice.actions;

export default vineyardsSlice.reducer;
